module.exports = __webpack_public_path__ + "static/media/pavel-kosov.28fffe04.jpg";